import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { AuthService } from 'src/app/shared/auth/auth.service'
import { ProfileStateService } from './services/profile-state.service'

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    standalone: false,
})
export class ProfileComponent implements OnInit {
    @Input() isInToolbar: boolean = false
    selectedInstallation$ = this.profileStateService.selectedInstallation$

    constructor(
        public authService: AuthService,
        public profileStateService: ProfileStateService,
        private cdr: ChangeDetectorRef
    ) {}
    ngOnInit(): void {
        this.selectedInstallation$.subscribe((installation) => {
            this.cdr.detectChanges()
        })
    }
}
